import React from 'react';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { SlackSettingsPanel } from '../components/SlackSettingsPanel';
import { Accordion } from '../components/ui/Accordion';
import { NotificationPreferencesPanel } from '../components/NotificationPreferencesPanel';
import { ChromeExtensionPanel } from '../components/ChromeExtensionPanel';
import { useAuth } from '../contexts/AuthContext';
import { User } from 'lucide-react';

export function UserSettingsPage() {
  const { featureFlags } = useAuth();
  return (
    <DashboardLayout title="User Settings">
      <div className="space-y-6">
        <Accordion>
          {/* Notification Preferences - Browser, Sound, Slack */}
          <NotificationPreferencesPanel />

          {/* Slack Integration */}
          <SlackSettingsPanel />

          {/* Chrome Extension — only when feature is enabled */}
          {featureFlags.download_codes_enabled && <ChromeExtensionPanel />}
        </Accordion>
      </div>
    </DashboardLayout>
  );
}
